var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFact4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "military-rank",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.95,
    height: 26.523,
    viewBox: "0 0 15.95 26.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(0.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M132.491,5.186l-4.932-.717L125.354,0l-2.206,4.469-4.932.717,3.569,3.479-.843,4.912,4.411-2.319,4.411,2.319-.842-4.912Z",
    transform: "translate(-118.216)",
    fill: "#3f2566"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    transform: "translate(0 13.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M110.03,256.656l-7.975-3.2V258l8.021,3.218L118,258v-4.542Z",
    transform: "translate(-102.055 -253.457)",
    fill: "#3f2566"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(0 18.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M110.03,365.352l-7.975-3.2V366.7l8.021,3.218L118,366.694v-4.542Z",
    transform: "translate(-102.055 -362.152)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFact4);
export default __webpack_public_path__ + "static/media/fact4.c3c66d43b68523c09e40052fa6efbdce.svg";
export { ForwardRef as ReactComponent };